<nav class="u-menubar" [ngStyle]="styles()" [ngClass]="styleClass()">
  @for (item of items(); track item) {
    @if (item.items?.length) {
      <u-button mat-button [matMenuTriggerFor]="menu">
        @if (item.icon) {
          <mat-icon class="menubar_icon">{{ item.icon }}</mat-icon>
        }
        <span [innerHTML]="item.label"></span>
        <mat-icon class="menubar_icon arrow">{{ 'keyboard_arrow_down' }}</mat-icon>
      </u-button>

      <mat-menu #menu="matMenu">
        @for (child of item.items; track child) {
          <u-button mat-menu-item (click)="onItemClick($event, child)">
            @if (child.icon) {
              <mat-icon class="menubar_icon">{{ child.icon }}</mat-icon>
            }
            <span [innerHTML]="child.label"></span>
          </u-button>
        }
      </mat-menu>
    }
  }
</nav>
